/* global process */

import { API_CATEGORIES } from 'consts';

const itemValue = ({ salesPrice, frameContractId }) =>
  frameContractId ? 0 : parseFloat(salesPrice);

const itemAffiliation = ({ frameContractId }) =>
  frameContractId ? 'with frame_contract' : 'without frame_contract';

const initialCategoriesValues = Object.values(API_CATEGORIES).reduce(
  (acc, value) => {
    acc[value] = false;
    return acc;
  },
  {}
);
const channelCategories = ({ categoryList = [] }) =>
  categoryList.reduce(
    (acc, item) => ({
      ...acc,
      [API_CATEGORIES[item]]: true,
    }),
    initialCategoriesValues
  );

/**
 * Use this if you need to add information about a channel to
 * an analytics event.
 */
export const analyzeChannel = (channel) => ({
  item_id: channel.id,
  item_name: channel.name,
  item_currency: channel.currencyCode || 'EUR',
  price: itemValue(channel),
  affiliation: itemAffiliation(channel),
  item_rating: channel.rating,
  item_brand: channel.supplierId,
  quantity: 1,
  ...channelCategories(channel),
});

export const channelsEcommerceEvent = ({
  event,
  channels = [],
  ...otherValues
}) => {
  const items = channels.map(analyzeChannel);
  const totalValue = items.reduce((sum, item) => sum + item.price, 0);

  return {
    event,
    ecommerce: {
      currency: items[0]?.item_currency,
      value: totalValue,
      items,
      ...otherValues,
    },
  };
};

export const E_COMMERCE_EVENTS = {
  addToWishlist: 'add_to_wishlist',
  addToCart: 'add_to_cart',
  purchase: 'purchase',
  removeFromWishlist: 'remove_from_wishlist',
  removeFromCart: 'remove_from_cart',
  beginCheckout: 'begin_checkout',
};

export const ENV = {
  production: 'production',
  staging: 'staging',
  development: 'development',
};

/**
 * A small wrapper around the GA interface, see more there https://bit.ly/2MNasx3
 */
export const pushAnalytics = (item, envs) => {
  window.dataLayer = window.dataLayer || [];
  item &&
    (!envs || envs.includes(process.env.RAILS_ENV)) &&
    window.dataLayer.push(item);
};
